!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react-apollo"), require("apollo-link-dedup"), require("apollo-link"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "react-apollo", "apollo-link-dedup", "apollo-link", "react"], t) : t(e.reactApolloNetworkStatus = {}, e.reactApollo, e.apolloLinkDedup, e.apolloLink, e.react);
}(this, function (e, t, r, n, o) {
  var i = "default" in o ? o.default : o,
      u = function u() {
    this.listeners = [];
  };

  u.prototype.addListener = function (e) {
    this.listeners.push(e);
  }, u.prototype.removeListener = function (e) {
    this.listeners = this.listeners.filter(function (t) {
      return t !== e;
    });
  }, u.prototype.dispatch = function (e) {
    this.listeners.forEach(function (t) {
      t(e);
    });
  };

  var a = i.createContext(void 0),
      s = {
    REQUEST: "REQUEST",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    CANCEL: "CANCEL"
  },
      c = function (e) {
    function t(t) {
      var r = t.dispatcher,
          n = t.enableBubbling;
      e.call(this), this.dispatcher = r, this.enableBubbling = !0 === n;
    }

    return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t, t.prototype.request = function (e, t) {
      var r = this,
          o = e.getContext(),
          i = !0;
      !0 === o.isNetworkStatusHandled || this.enableBubbling ? i = !0 !== o.isNetworkStatusHandled : e.setContext({
        isNetworkStatusHandled: !0
      }), i && this.dispatcher.dispatch({
        type: s.REQUEST,
        payload: {
          operation: e
        }
      });
      var u = t(e);
      return new n.Observable(function (t) {
        var n = !0,
            o = u.subscribe({
          next: function next(o) {
            n = !1, i && r.dispatcher.dispatch({
              type: s.SUCCESS,
              payload: {
                operation: e,
                result: o
              }
            }), t.next(o);
          },
          error: function error(o) {
            n = !1, i && r.dispatcher.dispatch({
              type: s.ERROR,
              payload: {
                operation: e,
                networkError: o
              }
            }), t.error(o);
          },
          complete: t.complete.bind(t)
        });
        return function () {
          i && n && r.dispatcher.dispatch({
            type: s.CANCEL,
            payload: {
              operation: e
            }
          }), o && o.unsubscribe();
        };
      });
    }, t;
  }(n.ApolloLink);

  function l(e) {
    var t = Object.getPrototypeOf(e),
        r = Object.assign(Object.create(t), e);
    return Object.keys(t).forEach(function (e) {
      "function" == typeof t[e] && (r[e] = t[e].bind(r));
    }), r;
  }

  var p = t.withApollo(function (e) {
    var n = e.client,
        s = e.children,
        p = e.enableBubbling,
        d = o.useMemo(function () {
      return new u();
    }, []),
        f = o.useMemo(function () {
      return function (e) {
        var t = e.client,
            n = e.dispatcher,
            o = e.enableBubbling;
        !t.queryManager && t.initQueryManager && t.initQueryManager();
        var i = new c({
          dispatcher: n,
          enableBubbling: o
        }).concat(t.link),
            u = l(t);
        return u.link = i, u.queryManager = l(u.queryManager), u.queryManager && (u.queryManager.link = i, u.queryManager.deduplicator = new r.DedupLink().concat(i)), u;
      }({
        client: n,
        dispatcher: d,
        enableBubbling: p
      });
    }, [n, d, p]);
    return i.createElement(t.ApolloProvider, {
      client: f
    }, i.createElement(a.Provider, {
      value: d
    }, s));
  });

  function d(e, t) {
    var r = o.useReducer(e, t),
        n = r[0],
        i = r[1],
        u = o.useContext(a);
    if (!u) throw new Error("`useApolloNetworkStatus` needs to be wrapped with `ApolloNetworkStatusProvider`.");
    return o.useLayoutEffect(function () {
      return u.addListener(i), function () {
        return u.removeListener(i);
      };
    }, [u]), n;
  }

  function f(e, t) {
    return e.query.definitions.some(function (e) {
      return "OperationDefinition" === e.kind && e.operation === t;
    });
  }

  function y(e) {
    return function (t, r) {
      if (void 0 === t && (t = 0), !f(r.payload.operation, e)) return t;

      switch (r.type) {
        case s.REQUEST:
          return t + 1;

        case s.ERROR:
        case s.SUCCESS:
        case s.CANCEL:
          return Math.max(t - 1, 0);
      }

      return t;
    };
  }

  function E(e) {
    return function (t, r) {
      if (!f(r.payload.operation, e)) return t;

      switch (r.type) {
        case s.REQUEST:
          return;

        case s.ERROR:
          var n = r.payload;
          return {
            networkError: n.networkError,
            operation: n.operation,
            response: n.result
          };

        case s.SUCCESS:
          var o = r.payload,
              i = o.result;
          return i && i.errors ? {
            graphQLErrors: i.errors,
            response: i,
            operation: o.operation
          } : t;
      }

      return t;
    };
  }

  var b = y("query"),
      h = y("mutation"),
      S = E("query"),
      v = E("mutation"),
      g = {
    numPendingQueries: 0,
    numPendingMutations: 0,
    queryError: void 0,
    mutationError: void 0
  };

  function k(e) {
    return !1 !== e.getContext().useApolloNetworkStatus;
  }

  e.ApolloNetworkStatusProvider = p, e.useApolloNetworkStatus = function (e) {
    e || (e = {});
    var t = e.shouldHandleOperation || k,
        r = o.useRef(t);
    return o.useEffect(function () {
      t !== r.current && (r.current = t);
    }, [e, t]), d(o.useMemo(function () {
      return function (e, t) {
        return r.current(t.payload.operation) ? function (e, t) {
          if (f(t.payload.operation, "subscription")) return e;
          var r = Object.assign({}, e);
          return r.numPendingQueries = b(r.numPendingQueries, t), r.numPendingMutations = h(r.numPendingMutations, t), r.queryError = S(r.queryError, t), r.mutationError = v(r.mutationError, t), Object.keys(e).some(function (t) {
            return r[t] !== e[t];
          }) ? r : e;
        }(e, t) : e;
      };
    }, []), g);
  }, e.useApolloNetworkStatusReducer = d, e.ActionTypes = s;
});